import { queryOptions } from '@tanstack/react-query';
import { getAmazonItemDeal, getAmazonItemDeals } from '../../api/getAmazonItemDealsAPI';
import { getCartDeals } from '../../api/getCartDealsAPI';
import { AMAZON_ITEM_REFETCH_MS } from './amazonItemFilters';

const amazonOfferRefetch = {
  // Offline, the default mode pauses a refetch and keeps the old rows; failing it drops them.
  networkMode: 'always',
  retry: false,
  refetchInterval: AMAZON_ITEM_REFETCH_MS,
  refetchOnWindowFocus: true,
} as const;

export const amazonItemDealsQuery = queryOptions({
  queryKey: ['amazonItemDeals'],
  queryFn: getAmazonItemDeals,
  ...amazonOfferRefetch,
});

export const amazonItemDealQuery = (asin: string) =>
  queryOptions({
    queryKey: ['amazonItemDeal', asin],
    queryFn: () => getAmazonItemDeal(asin),
    ...amazonOfferRefetch,
  });

export const cartDealsQuery = (cartId: string) =>
  queryOptions({
    queryKey: ['cartDeals', cartId],
    queryFn: () => getCartDeals(cartId),
    ...amazonOfferRefetch,
  });
